import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const FeatureCard = ({ 
  title, 
  description, 
  image, 
  link,
  index = 0 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      <Link to={link} className="block h-full">
        <div className="bg-[#8ae9bb]/50 rounded-2xl overflow-hidden shadow-md hover:shadow-xl h-full transition-all duration-300">
          {image && (
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src={image}
                alt={title}
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
              />
            </div>
          )}
          <div className="p-5">
            <h3 className="text-lg font-semibold text-[#032925] mb-2">
              {title}
            </h3>
            {description && (
              <p className="text-sm text-[#032925]/70 mb-4 line-clamp-2">
                {description}
              </p>
            )}
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-[#032925] hover:text-[#1a1308] transition-colors">
              Mehr erfahren
              <ArrowRight className="w-4 h-4" />
            </span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default FeatureCard;
